/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class InviteErrorStateService extends Service {
  @tracked maskedEmail: string | null = null;
}
